import React, { useState } from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import NotificationsIcon from "@mui/icons-material/Notifications";
import Badge from "@mui/material/Badge";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import AccountCircle from "@mui/icons-material/AccountCircle";
import MenuIcon from "@mui/icons-material/Menu";
import Box from "@mui/material/Box";
import useMediaQuery from "@mui/material/useMediaQuery";
import Logo from "../../Assets/logo.jpg";
import { ExitToApp } from "@mui/icons-material";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  useTheme,
  Avatar,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

function SideBarNavBar({ toggleDrawer }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const isLargeScreen = useMediaQuery("(min-width:1440px)");
  const navigate = useNavigate();
  const theme = useTheme();
  
  const LoginUser = localStorage.getItem("Login_User_Community_All_Data");
  const LoginUserDetails = JSON.parse(LoginUser);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogoutClick = () => {
    setLogoutDialogOpen(true);
    handleClose();
  };

  const handleLogoutConfirm = () => {
    setIsLoggingOut(true);
    setTimeout(() => {
      localStorage.clear();
      setIsLoggingOut(false);
      setLogoutDialogOpen(false);
      navigate("/");
    }, 3000);
  };

  const handleLogoutCancel = () => {
    setLogoutDialogOpen(false);
  };


    const handleUserProfileClick = () => {
      
      const { user_type, id, email, role} = LoginUserDetails || {};
      
      let path = "/patient-user/user-profile";
      if (role === "2") {
        path = `/patient-user/user-profile/${role}`;
      } else if (role === "3") {
        path = `/provider-user/user-profile/${role}`;
      } else if (user_type === "admin") {
        path = `/admin-user/user-details/${user_type}/${id}/${email}`;
      } else if (role === "4") {
        path = `/vendor-user/user-profile/${role}`;
      }
      navigate(path);
      handleClose();
    };


 //console.log("LoginUserDetails===",LoginUserDetails);
  return (
    <>
      <AppBar
        position="static"
        sx={{
          backgroundColor: "#FFFFFF",
          color: "black",
          borderBottom: "1px solid #2a2a2a",
        }}
      >
        <Toolbar sx={{ justifyContent: "space-between", backgroundColor:"#0077BE" }}>
          <Box display="flex" alignItems="center">
            {!isLargeScreen && (
              <IconButton
                edge="start"
                color="inherit"
                aria-label="open drawer"
                onClick={toggleDrawer("top", true)}
                sx={{ marginRight: 1 }}
              >
                <MenuIcon />
              </IconButton>
            )}
            <img
              src={Logo}
              alt="Inspire Community"
              style={{ maxWidth: "58%", maxHeight: 72 , width:"55%"}}
            />
          </Box>         
                <Toolbar >                    
                    <Box sx={{ display: { xs: "none", md: "flex" }, gap: 2 }}>
                    <Button href="#" sx={{ color: "text.primary", fontWeight: "bold" }}>
                        Home
                    </Button>
                    <Button href="#" sx={{ color: "text.primary", fontWeight: "bold" }}>
                        Courses
                    </Button>
                    <Button href="#" sx={{ color: "text.primary", fontWeight: "bold" }}>
                        Members
                    </Button>
                    <Button href="#" sx={{ color: "text.primary", fontWeight: "bold" }}>
                        Leaderboard
                    </Button>
                    </Box>
                </Toolbar>
            <IconButton color="inherit" style={{marginRight:-434}}>
                <Badge badgeContent={4} color="error">
                <NotificationsIcon />
                </Badge>
            </IconButton>
          <IconButton
            edge="end"
            color="inherit"
            aria-label="user account"
            onClick={handleMenu}
          >
            <AccountCircle />
           </IconButton>
            
           <Menu
              anchorEl={anchorEl}
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
              keepMounted
              transformOrigin={{ vertical: "top", horizontal: "right" }}
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              <MenuItem onClick={handleUserProfileClick}>
                <Avatar alt={LoginUserDetails?.name} src="/static/images/avatar/1.jpg" />
                <div style={{ marginLeft: "10px" }}>
                  {LoginUserDetails?.name} <br />
                  Role:{" "}
                  {LoginUserDetails?.role === "1"
                    ? "Admin"
                    : LoginUserDetails?.role === "2"
                    ? "Patient"
                    : LoginUserDetails?.role === "3"
                    ? "Provider"
                    : LoginUserDetails?.role === "4"
                    ? "Vendor"
                    : "Unknown"}
                </div>
              </MenuItem>

              <MenuItem onClick={handleLogoutClick}>
                <Button startIcon={<ExitToApp />} style={{ color: "red" }}>
                  Logout
                </Button>
              </MenuItem>
            </Menu>

        </Toolbar>
      </AppBar>
      <Dialog
        open={logoutDialogOpen}
        onClose={handleLogoutCancel}
        aria-labelledby="logout-dialog-title"
      >
        <DialogTitle id="logout-dialog-title">Logout Confirmation</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to logout?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleLogoutCancel} sx={{ color: theme.palette.secondary.main }}>
            No
          </Button>
          <Button onClick={handleLogoutConfirm} sx={{ color: theme.palette.primary.main }}>
            {isLoggingOut ? <CircularProgress size={24} /> : "Yes"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default SideBarNavBar;
